module.exports = __webpack_public_path__ + "static/apple-store-9f216fe4707a9f0432d09d9aea43bc2e.svg";